import { FC } from "react"
import { useWalletCounters } from "@/hooks/useWalletCounters"
import { WalletCounters } from "@/ui/WalletCounters"

export const InventoryWalletCounters: FC = () => {
  const view = useWalletCounters()

  return <WalletCounters {...view} />
}
